export default "__VITE_ASSET__C1940r3d__"